import { Dropdown }    from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'
import { Button }      from 'primereact/button'
import { useTranslation } from 'react-i18next'
import { useLocalizationLabels } from '../../../context/LocalizationLabelContext'

interface UnitProps {
  unitOptions: string[]
  value:       string
  onChange:    (v: string) => void
}

function UnitSelect({ unitOptions, value, onChange }: UnitProps) {
  const { t } = useTranslation('mainStats')
  const { statsLabels } = useLocalizationLabels()
  if (unitOptions.length === 0) return null
  const options = unitOptions.map(code => ({
    label: statsLabels.units?.[code]?.label ?? code,
    value: code,
  }))
  return (
    <span className="p-float-label">
      <Dropdown
        inputId="unit-select"
        value={value}
        options={options}
        onChange={e => onChange(e.value)}
      />
      <label htmlFor="unit-select">{t('filter.unit')}</label>
    </span>
  )
}

interface CompareGeoProps {
  compareGeoList: string[]
  value:          string[]
  onChange:       (v: string[]) => void
  disabled?:      boolean
}

function CompareGeoSelect({ compareGeoList, value, onChange, disabled }: CompareGeoProps) {
  const { t } = useTranslation('mainStats')
  const { geoNameOptionLabels } = useLocalizationLabels()
  if (compareGeoList.length === 0) return null
  const options = compareGeoList.map(g => ({
    label: geoNameOptionLabels[g]?.label ?? g,
    value: g,
  }))
  return (
    <span className="p-float-label">
      <MultiSelect
        inputId="compare-geo"
        value={value}
        options={options}
        onChange={e => onChange(e.value)}
        selectionLimit={2}
        maxSelectedLabels={2}
        selectedItemsLabel={t('filter.nSelected')}
        showSelectAll={false}
        panelHeaderTemplate={() => null}
        disabled={disabled}
      />
      <label htmlFor="compare-geo">{t('filter.compareWith')}</label>
    </span>
  )
}

interface ApplyButtonProps {
  isDirty: boolean
  onApply: () => void
}

function ApplyButton({ isDirty, onApply }: ApplyButtonProps) {
  const { t } = useTranslation('mainStats')
  return (
    <div className="filter-item filter-apply">
      <Button
        label={t('filter.applyFilters')}
        onClick={onApply}
        disabled={!isDirty}
        size="small"
      />
    </div>
  )
}

export { UnitSelect, CompareGeoSelect, ApplyButton }
